import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from '@systemeio/util'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { TAGS_API } from '../api/tags-api'
import { TagListAllInterface } from '../types/tag-interface'

export const useTagsAll = (shouldFetch = true) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, TagListAllInterface>({
    method: RequestMethodsEnum.get,
    afterFetch: data => {
      return {
        hasMore: data.hasMore,
        items: data.items.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        }),
      }
    },
  })

  const { data: tags, mutate } = useControlledSwr(
    () => [`${TAGS_API}/list-all`, RequestModuleEnum.Tags],
    fetcher,
    undefined,
    shouldFetch && !!user,
  )

  return { tags, mutate }
}
